import { useState } from "react";
import emailjs from "emailjs-com";
import "./Appointment.css";
import Header from "../../components/Header/Header";


function Appointment() {
  const [formData, setFormData] = useState({
    name: "",
    telephone: "",
    email: "",
    counsellingType: "",
    counsellingProgram: "",
    message: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!formData.consent) {
      alert("You must agree to receive appointment messages.");
      return;
    }

    emailjs
      .send(
        "service_jxqgorq",
        "template_rj3u7eg",
        formData,
        "V4DSqKwwqaNwNPIGG"
      )
      .then(
        (result) => {
          alert("Appointment request sent successfully!");
        },
        (error) => {
          alert("Failed to send the message. Please try again.");
        }
      );
  };

  return (
    <>
      <Header />
      <div className="appointment-container">
        <h1 className="title">Request an Appointment</h1>
        <p className="subtitle">
          Please fill out the form, and our team will contact you. <br />
          Appointments are available in person and online, or you can call us at{" "}
          <a href="tel:6477262999" className="phone-link">647-726-2999</a>.
        </p>

        <form className="form-box" onSubmit={sendEmail}>
          <div className="form-row">
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Full Name"
                required
              />
            </div>

            <div className="form-group">
              <label>Telephone *</label>
              <input
                type="text"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                placeholder="416-123-1234"
                required
              />
            </div>

            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="email address"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Type of Counselling Required *</label>
              <select
                name="counsellingType"
                value={formData.counsellingType}
                onChange={handleChange}
                required
              >
                <option value="">Please select</option>
                <option>Child / Adolescence Support</option>
                <option>Parents Support</option>
                <option>Family Counselling</option>
                <option>Individual Counselling</option>
                <option>Couple Therapy</option>
              </select>
            </div>

            <div className="form-group">
              <label>Counselling Program</label>
              <select
                name="counsellingProgram"
                value={formData.counsellingProgram}
                onChange={handleChange}
              >
                <option>Please select</option>
                <option>Emotional Regulation Support</option>
                <option>Student Empowerment & Engagement Program</option>
                <option>Student Achievement & Well-Being Support Program</option>
                <option>School Anxiety Support</option>
                <option>Parent & School Success Partnership Program</option>
                <option>Inclusive Parent-School Empowerment Program</option>
                <option>Mindful Pathways Program</option>
                <option>Career Pathway Support</option>
                <option>Postsecondary Success Support Program</option>
                <option>Special Minds Neurodiversity Growth Program(ADHD AND ASD)</option>
                <option>Social Skills Friendship Support</option>
                <option>Anger Management Support</option>
                <option>OCD Support</option>
                <option>Trauma Support</option>
                <option>Anxiety & Depression</option>
                <option>Relationship Counselling</option>
                <option>Group Therapy</option>
                <option>Play Therapy</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>How Can We Help? *</label>
            <textarea
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              placeholder="Please provide any details that may help us assist you."
              required
            ></textarea>
          </div>

          <div className="consent-box">
            <label className="checkbox-container">
              <input
                type="checkbox"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
              />{" "}
              I Agree
            </label>
            <p className="consent-text">
              I agree to receive messages by text regarding my appointment.
              You may opt out anytime by replying STOP.
            </p>
          </div>

          <button className="submit-btn" type="submit">
            Request an Appointment →
          </button>
        </form>
      </div>
    </>
  );
}

export default Appointment;
